<template lang="pug">
.auth-header
  .auth-header__content
    .auth-header__column.auth-header__column--left
      a.auth-header__link(:href="getHomeLink", target="_blank") На сайт игры
      button.auth-header__link(@click="downloadGameCenter") Скачать игру

    .auth-header__column.auth-header__column--right
      template(v-if="isUserInProject")
        .auth-header__name {{ user.display_name }}
        button.auth-header__link(@click="logout") Выйти
      template(v-else-if="isUserAuthedNotRegistered")
        .auth-header__name {{ getUserEmail }}
        button.auth-header__link(@click="projectReg") Зарегистрироваться
      template(v-else)
        button.auth-header__link(@click="login") Войти
        button.auth-header__link(@click="signup") Зарегистрироваться

</template>

<script>
import env from "@chronos/frontend-base/src/libs/tools/Environment";

import { createNamespacedHelpers } from "vuex";
const { mapState, mapGetters } = createNamespacedHelpers("global");

export default {
  name: "AuthHeader",

  computed: {
    ...mapState(["user"]),
    ...mapGetters(["isUserAuthedNotRegistered", "isUserInProject"]),

    getHomeLink() {
      return env.getHomePage();
    },

    getUserEmail() {
      return this.$authService.getUserEmail();
    },
  },

  methods: {
    downloadGameCenter() {
      this.$authService.downloadGameCenter();
    },

    logout() {
      this.$authService.logout();
    },

    login() {
      this.$authService.showSignin();
    },

    signup() {
      this.$authService.showSignup();
    },

    projectReg() {
      this.$authService.showProjectReg();
    },
  },
};
</script>

<style lang="scss">
@import "../style/auth-header.scss";
</style>
